export default __webpack_public_path__ + "static/media/CRS_7101-HDR-min.357c61bb.jpg";